<template>
  <div>
    <!-- <h4 class="text-primary mb-4">{{mins}}</h4> -->

    <VueRecordVideo @result="on_video" @stream="on_stream" ref="recorder" mimeType="video/webm" hidden/>

    <div :style="{'display': src ? 'none' : 'block'}">
      <div class='video-content'>
        <div class="video-overlay">
          <i class='fad fa-user'></i>
        </div>
        <video ref='preview' autoplay muted class="video-preview" key="webcam-preview"/>
      </div>

      <br>
      <LoadingButton key="uploading-button" v-if="uploading" :loading="true" variant="secondary" @click="record_video">Record</LoadingButton>
      <LoadingButton key="recording-button" v-else-if="!recording" :loading="false" variant="secondary" @click="record_video">Record</LoadingButton>
      <b-button v-else variant="secondary" @click="stop_video">Stop</b-button>
      <span> Duration: {{seconds}}s <span v-if="max_limit">(Max {{max_limit}}s)</span></span>
    </div>
    <div :style="{'display': src ? 'block' : 'none'}">
      <div class='video-content'>
        <video :src="src" controls autoplay class="video-preview" key="video-preview"/>
      </div>

      <br>
      <LoadingButton variant="secondary" @click="src = null" class="mr-2" :disabled="uploading">Rerecord</LoadingButton>
      <LoadingButton variant="primary" @click="upload" :loading="uploading" :uploading_progress='uploading_progress' post_upload="Transcribing">Upload</LoadingButton>
    </div>
  </div>
</template>

<script>
import { db, storage } from '@/main.js'
import moment from 'moment/src/moment'
import { VueRecordVideo } from "@codekraft-studio/vue-record"

// TODO max audio length

export default {
  props: ['upload_prefix', 'on_complete', 'existing_video', 'max_limit', 'uploading_progress'],
  components: {VueRecordVideo},
  data() {
    return {
      seconds: 0,
      interval: undefined,
      recording: false,
      media: undefined,
      uploading: false,
      src: null,
      raw_data: null
    }
  },
  mounted() {
    this.seconds = 0
    this.get_media()
  },
  beforeDestroy() {
    if (this.media) {
      try {
        this.media.getTracks().forEach(function(track) {
          track.stop()
        });
      } catch(err) {
        console.warn(err)
      }
    }
  },
  computed: {
    mins() {
      return moment("2015-01-01").startOf('day').seconds(this.seconds).format('mm:ss')
    }
  },
  methods: {
    async upload() {
      this.uploading = true

      try {
        await this.on_complete(this.raw_data)
      } catch (err) {
        console.error(err)
        this.$swal({title: 'Uploading failed', text: "We couldn't upload your video, please contact support", icon: 'warning'})
      }

      this.uploading = false
    },
    async get_media() {
      let media = await navigator.mediaDevices.getUserMedia({audio: true, video: true})

      if (!media) {
        this.$swal({title: 'No media device', text: `We couldn't find a media device, please make sure you have allowed access to your camera and microphone and refresh the page`, icon: 'warning'})
      }

      this.media = media

      if (media) {
        let track = media.getVideoTracks()[0]
        let constraints = {
          aspectRatio: 1.33,
          frameRate: {ideal: 25, max: 30},
        }
        track.applyConstraints(constraints).then((a) => {console.log(a)})
      }

      this.$forceUpdate()
      this.$nextTick(() => {
        this.$refs.preview.srcObject = this.media
      })
    },
    update_time() {
      this.seconds++
      if (this.max_limit && this.seconds > this.max_limit) {
        this.stop_video()
        this.$swal({title: 'Video too long', text: `Video should be max ${this.max_limit} seconds long`, icon: 'warning'})
      }
    },
    record_video() {
      this.recording = true
      this.$refs.recorder.start()
      console.log('Start')

      this.interval = setInterval(this.update_time, 1000)
    },
    async stop_video() {
      this.recording = false
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = undefined
      }

      console.log('Stop')

      console.log(this.$refs.recorder)

      await this.$refs.recorder.stop()
    },
    async on_video(data) {
      console.log('Result')
      console.log(data)
      let blob = window.URL.createObjectURL(data)

      console.log(data)
      console.log(blob)

      this.raw_data = data
      this.src = blob

      this.seconds = 0
    },
    async on_stream(stream) {
      console.log('stream...')

      let track = stream.getVideoTracks()[0]


      let constraints = {
        // width: { min: 640, ideal: 640, max: 1280 },
        // height: { min: 480, ideal: 480, max: 920 },
        // aspectRatio: 1.33,
        frameRate: {ideal: 25, max: 30},
        // advanced: [
        //   {width: 1920, height: 1280},
        //   {aspectRatio: 1.333}
        // ]
      }

      track.applyConstraints(constraints).then((a) => {console.log(a)})

      // let blob = window.URL.createObjectURL(stream)
      // this.src = stream
    }
  },
}
</script>

<style lang="scss">


</style>
